/**
 * Synthetic key used to surface a snapshot dashboard's single-day date pill.
 * The compute hook strips this key and promotes its value to `snapshotDate`.
 */
export const SNAPSHOT_DATE_FILTER_KEY = '__snapshotDate'
